import React from "react";
import Immutable from "immutable";
import Cube19Dialog from "js/common/views/dialog";
import ImmutableReactSelect from "js/common/views/inputs/immutable-react-select";
import {TextButton} from "js/common/views/inputs/buttons";

// "Standard" matches the wording users pick from when creating a dashboard.
const typeLabel = (dashboard) =>
    dashboard.getIn(["json", "layoutType"]) === "gamified" ? "Gamified" : "Standard";

// Tab names can be arbitrarily long and have no spaces to wrap on, which would
// otherwise stretch the dialog past the viewport.
const tabNameStyle = {
  display: "inline-block",
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  verticalAlign: "bottom"
};

const CopyTabDialog = ({open, tabName, dashboards, onCancel, onConfirm}) => {
  const [selectedId, setSelectedId] = React.useState(null);

  React.useEffect(() => {
    if (open) {
      setSelectedId(null);
    }
  }, [open]);

  const hasDestinations = !dashboards.isEmpty();

  const options = dashboards.map(dashboard => Immutable.Map({
    value: dashboard.get("id"),
    label: dashboard.get("name"),
    itemDescription: typeLabel(dashboard)
  }));

  return (
      <Cube19Dialog
          open={open}
          onClose={onCancel}
          title="Copy Tab To..."
          maxWidth="xs"
          actions={<div style={{display: "flex", gap: "8px", justifyContent: "flex-end", alignItems: "center"}}>
            <TextButton label="Cancel" onClick={onCancel} />
            {hasDestinations && (
                <TextButton
                    type="primary"
                    label="Copy"
                    testId="copy-tab-confirm"
                    disabled={selectedId === null}
                    onClick={() => onConfirm(selectedId)}
                />
            )}
          </div>}>
        <div data-test-id="copy-tab-dialog">
          {!hasDestinations && (
              <p style={{margin: 0}}>
                There are no other dashboards you can edit, so there's nowhere to copy this tab to.
              </p>
          )}
          {hasDestinations && (
              <>
                <p style={{marginTop: 0, marginBottom: 12}}>
                  Choose where to copy <strong style={tabNameStyle} title={tabName}>{tabName}</strong>
                </p>
                <ImmutableReactSelect
                    isMulti={false}
                    options={options}
                    selectedValue={selectedId}
                    onChange={setSelectedId}
                    showItemDescriptions
                    placeholder="Select a dashboard"
                    dataTestId="copy-tab-dashboard-select"
                />
              </>
          )}
        </div>
      </Cube19Dialog>
  );
};

export default CopyTabDialog;
